
var municipalitySelect = document.getElementById("municipalitySelect");
var forsamlingSelect = document.getElementById("forsamlingSelect");

var calcTaxForm = document.getElementsByClassName("Taxform")[0];
var manadslonInput = document.getElementById("manadslon")

var omvandRadio = document.getElementsByClassName('radioButton');
var regnrInput = document.getElementById("regnrFromTaxForm");        


const storage = () => localStorage.Data ? JSON.parse(localStorage.Data) : {};
const save = (data) => localStorage.Data = JSON.stringify(data);

function submitTaxForm() {
    var data = createFormData(calcTaxForm);
    var action = calcTaxForm.getAttribute("action");

    if(data.manadslon > 0){

        var httpRequest = {
            body: JSON.stringify(data),
            method: "post"
        };

        httpFetchHtml(action, httpRequest, function(html) {
            var container = document.getElementById("TaxResult");

            container.innerHTML = html;
        } );

      //  postAsync(action, data, );
    }
}


if(calcTaxForm){
    calcTaxForm.addEventListener("submit", (e) => {
        e.preventDefault();
        submitTaxForm()
    })
}

if(municipalitySelect) {
    municipalitySelect.addEventListener("change", (e) => {

        const municipalityUrl = e.target.value;
        const data = storage();

       // window.history.pushState({}, '', "/" + municipalityUrl);


        data.municipalityUrl = municipalityUrl;
        save(data);

        getForsamlingForMunicipality(municipalityUrl);
        submitTaxForm();
    })
}

if(forsamlingSelect) {
    forsamlingSelect.addEventListener("change", (e) => {
        
        var data = storage();

        const forsamlingId = e.target.value;

        data.forsamlingId = forsamlingId;

        var newUrl = "/" + data.municipalityUrl + "/" + forsamlingId;


//        window.history.pushState({data: newUrl}, "", newUrl);
        submitTaxForm();
        save(data);
    })
}

function changeCalcType(type){

    var radio = document.querySelector('[name="omvand"][value="' + type + '"]');
       
    radio.checked = true;

    submitTaxForm();
}


function getForsamlingForMunicipality(municipalityId){

    httpPost("getForsamling", {municipalityId}, null, renderForsamlingSelectBox);
}

function renderForsamlingSelectBox(forsamlingar){

    var data = storage();

    forsamlingSelect.classList.remove("d-none");
    forsamlingSelect.innerHTML = '';
    
    var defaultSelect = document.createElement("option");

    defaultSelect.value = 0;
    //TODO defaultSelect.text = "Ej svenska kyrkan"
    defaultSelect.text = "-- Ej svenska kyrkan --"

    forsamlingSelect.append(defaultSelect)
    forsamlingar.forEach(element => appendOption(forsamlingSelect, element.forsamlingId, element.forsamling));

    if(data.forsamlingId){
        
        var element = forsamlingar.find(e => e.forsamlingId === data.forsamlingId); 
        if(element)
            forsamlingSelect.value = data.forsamlingId;
    }

}

function appendOption(selectElement, value, text){

    var option = document.createElement("option");

    option.value = value;
    option.text = text;

    selectElement.append(option);
}

if(calcTaxForm)
    initTaxForm();

function initTaxForm(){

    var data = storage();

    if(data.municipalityUrl) {
        var option = municipalitySelect.querySelector('[value="' + data.municipalityUrl + '"]');
        municipalitySelect.value = option.value 

        getForsamlingForMunicipality(option.value);
    }

    if(data.car) {
        var regnrInput = document.getElementById("regnrFromTaxForm");        

        regnrInput.value = data.car.regnr;

        getBilformanDropdown(data.car.regnr)

        var BilformanForm = document.getElementById("BilformanForm");
        BilformanForm.classList.add("show");
    }

}

function setGeoLocation(){
    getLocation(() => {
        
        var location = storage();

        if(location.result){
        
            var option = municipalitySelect.querySelector('[value="' + location.result.url + '"]');
            municipalitySelect.value = option.value 

            getForsamlingForMunicipality(option.value);
        }
        else {
            //outside sweden
            console.log("municipality does not exist in sweden");
        }
    });
}

function getLocationForJobs(){
    var callback = (data) => {

        if(data.redirectUrl)
            window.location.href = "/lediga-tjanster/" + data.redirectUrl;
    }
    getLocation(callback)
}

function getLocation(callback) 
{
    if (navigator.geolocation) {
        
        navigator.geolocation.getCurrentPosition(e => showPosition(e, callback));
        sessionStorage.location = true;
        
    } else { 
        console.log("Geolocation is not supported by this browser.");
    }
}

function showPosition(position, callback) 
{
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    codeLatLng(lat, lng, callback);
}

function codeLatLng(lat, lng, callback){
    
    var url = "/geolocation.php?lat=" + lat +"&lng=" + lng;
    fetch(url)  
    .then((response) => {
    return response.json();
    })
    .then((data) => {

    save(data);

    if(callback)
        callback(data);
    });
}	